export const STAFF_MEMBERS = [
  "Сайхнаа",
  "Энхбаяр",
  "Ууганаа",
  "Булгаа",
] as const;

export const CONSULTATION_STATUSES = [
  "new",
  "phone_consulted",
  "callback",
  "office_consulted",
] as const;

export type ConsultationStatus = (typeof CONSULTATION_STATUSES)[number];

export type StaffMember = (typeof STAFF_MEMBERS)[number];

export function isUnclaimedLead(assignedTo: string | null | undefined) {
  return !assignedTo?.trim();
}
